<template>
  <div class="container-login">
    <v-form ref="form" autocomplete="off">
      <v-container fluid ma-0 pa-0 style="width: 100% !important; max-width: 100% !important">
        <div class="mx-auto" style="max-width: 700px;">
          <v-row>
            <!-- <v-col cols="12"><div style="height: 40px;"></div></v-col> -->
            <v-col cols="12" class="text-center text-4xl font-semibold">
              <font class="textcolor1--text">SmartLink </font
              ><font class="light-blue--text textcolor2--text">Platform</font>
            </v-col>
            <v-col cols="12"><div style="height: 30px;"></div></v-col>
            <v-col cols="12" class="text-center text-3xl font-semibold textcolor1--text blue--text">
              Account Request
            </v-col>
            <v-col cols="12" class="text-center light-blue--text">
              <a @click="$router.push('/login')" class="underline">or sign in to your account</a>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                ref="usrId"
                v-model="insertData.usrId"
                placeholder="Email Address"
                :rules="rules.usrId"
                required
                dense
                solo
                height="40"
                class="account-field"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                ref="usrNm"
                v-model="insertData.usrNm"
                placeholder="Name"
                :rules="rules.usrNm"
                required
                dense
                solo
                height="40"
                class="account-field account-name"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                ref="compNm"
                v-model="insertData.compNm"
                placeholder="Company Name"
                :rules="rules.compNm"
                required
                dense
                solo
                height="40"
                class="account-field"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                ref="compAddr"
                v-model="insertData.compAddr"
                placeholder="Company Address"
                :rules="rules.compAddr"
                dense
                solo
                height="40"
                class="account-field"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="d-inline-flex">
              <v-text-field
                ref="usrPwd"
                v-model="insertData.usrPwd"
                type="password"
                placeholder="Password"
                :rules="[validationUtils.passwordRules]"
                autocomplete="new-password"
                required
                dense
                solo
                height="40"
                class="account-field"
                :maxlength="20"
              ></v-text-field>
              <v-tooltip top :max-width="tooltipWidth" style="questionToolTip">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-icon class="btn-tooltip-pw pt-3 pl-1">
                      far fa-question-circle
                    </v-icon>
                  </div>
                </template>
                <span v-html="$t('msg.users.questionIconTooltip')"> </span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                ref="usrPwdCfm"
                v-model="insertData.usrPwdCfm"
                type="password"
                placeholder="Password Confirm"
                :rules="rules.usrPwdCfm"
                @blur="passwordConfirm()"
                :error="pwdCfmErr"
                :error-messages="pwdCfmErrMsg"
                required
                dense
                solo
                height="40"
                class="account-field"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6"> </v-col>
            <v-col cols="12" sm="6">
              <v-btn block x-large color="primary" @click="save()">
                Request<v-icon class="ml-3" small>fa fa-thumbs-up</v-icon></v-btn
              >
            </v-col>
            <v-col cols="12" class="text-right">
              By creating an account, you agree to our <a class="underline">Terms of Service</a> and
              <a class="underline">Privacy Policy</a>
            </v-col>
          </v-row>
        </div>
      </v-container>
      <dialogWindow
        ref="AccountConfirmDialog"
        title="Create Account"
        :info="insertData.usrId"
        size="max"
        detail="Would you like to sign up with the information you entered?"
        color="confirmation"
        :showCancel="true"
        @select-ok="saveOk()"
      >
      </dialogWindow>
      <dialogWindow
        ref="AccountDialog"
        :info="checkDialogTitle"
        size="max"
        :detail="checkDialogInfo"
        :color="checkDialogColor"
        @select-ok="closeDialog()"
      >
      </dialogWindow>
    </v-form>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

export default {
  components: {
    dialogWindow,
  },

  data: () => ({
    pwdValid: false,
    pwdCfmErr: false,
    pwdCfmErrMsg: undefined,
    insertData: {
      usrId: '',
      usrNm: '',
      compNm: '',
      compAddr: '',
      usrPwd: '',
      usrPwdCfm: '',
      menuAuth: '',
    },
    rules: {
      usrId: [
        (v) => !!v || 'Email Address is required',
        (v) => v.length <= 52 || `Email Address max length is 52.`,
        (v) =>
          /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i.test(
            v
          ) || 'Email Address must be valid',
      ],
      usrNm: [
        (v) => !!v || 'Name is required',
        (v) => v.length <= 100 || `Name max length is 100.)`,
      ],
      compNm: [
        (v) => !!v || 'Company Name is required',
        (v) => v.length <= 50 || `Company Name max length is 50.`,
      ],
      usrPwd: [
        (v) => !!v || 'Password is required',
        (v) => v.length <= 50 || `Password max length is 50.`,
      ],
      usrPwdCfm: [
        (v) => !!v || 'Confirm Password is required',
        (v) => v.length <= 50 || `Confirm Password max length is 50.`,
      ],
      compAddr: [(v) => v.length <= 500 || `Confirm Password max length is 500.`],
    },
    formHasErrors: false,
    checkDialogColor: 'success',
    checkDialogTitle: '',
    checkDialogInfo: '',
    tooltipWidth: 300,
  }),

  computed: {
    formData() {
      return {
        usrId: this.insertData.usrId,
        usrNm: this.insertData.usrNm,
        compNm: this.insertData.compNm,
        compAddr: this.insertData.compAddr,
        usrPwd: this.insertData.usrPwd,
        usrPwdCfm: this.insertData.usrPwdCfm,
      };
    },
  },
  mounted() {
    setTimeout(() => {
      this.$refs.usrId.focus();
    }, 300);
    this.$store
      .dispatch('getMenuListCommon')
      .then((res) => {
        this.insertData.menuAuth = JSON.stringify(res);
      })
      .catch((ex) => {
        this.$refs.AccountDialog.dialog = true;
        this.checkDialogColor = 'error';
        this.checkDialogTitle = 'Error';
        this.checkDialogInfo = 'Connect failed. Please contact administrator.';
      });
  },

  methods: {
    _chkPwd() {
      const result = this.insertData.usrPwd === this.insertData.usrPwdCfm;
      return result;
    },

    save() {
      this.formHasErrors = false;

      // alert(JSON.stringify(this.formData));

      Object.keys(this.insertData).forEach((key) => {
        if (this.formData[key] && this.formData[key] === '') {
          this.formHasErrors = true;
          this.$refs[key].validate(true);
        }
      });

      if (!this.formHasErrors && this.passwordConfirm()) {
        // this.dialog = true;
        this.$refs.AccountConfirmDialog.dialog = true;
      }
    },

    saveOk() {
      this.$store
        .dispatch('membership/putMemberInfo', this.insertData)
        .then((res) => {
          const status = this.$store.getters['membership/status'];
          const compPutStatus = this.$store.getters['membership/compPutStatus'];
          if (!status) {
            const err = 'Exception occured during save data info.';
            throw err;
          }
          let userExist = res.isExist;
          if (userExist) {
            this.$refs.AccountDialog.dialog = true;
            this.checkDialogColor = 'warning';
            this.checkDialogTitle = 'Account Exist';
            this.checkDialogInfo = `Your email account is already exist. If you forget your password, please reset it in "Forgot your password?`;
          } else {
            if (compPutStatus) {
              this.$refs.AccountDialog.dialog = true;
              this.checkDialogColor = 'warning';
              this.checkDialogTitle = 'Verification Email';
              this.checkDialogInfo = `Verification Email was sent.Please check the email you input.\nYour company ${res.compId} is not registered in our system. Please contact smartlink@cyberlogitec.com`;
            } else {
              this.$refs.AccountDialog.dialog = true;
              this.checkDialogColor = 'success';
              this.checkDialogTitle = 'Verification Email';
              this.checkDialogInfo = 'Verification Email was sent.Please check the email you input';
            }
          }
        })
        .catch((err) => {
          this.$refs.AccountDialog.dialog = true;
          this.checkDialogColor = 'error';
          this.checkDialogTitle = 'Error';
          this.checkDialogInfo = 'Exception occured during save data info.';
        });
    },

    passwordConfirm() {
      const checkResult = this._chkPwd();

      this.pwdValid = checkResult ? true : false;
      this.pwdCfmErr = checkResult ? false : true;
      this.pwdCfmErrMsg = checkResult
        ? undefined
        : 'Password is different. Please check input password!';

      return checkResult;
    },

    closeDialog() {
      if (this.checkDialogColor == 'success') this.$router.push('/login');
    },
  },
};
</script>

<style>
.container-login .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
  height: auto !important;
}
.theme--light .account-field.account-name input {
  color: #1c0e59 !important;
}
</style>
